import { VoucherCard } from 'domains/voucher'
import { Alert } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  vouchers    : PropTypes.arrayOf(PropTypes.object),
  onClickItem : PropTypes.func
}

const VoucherList = ({ vouchers, onClickItem }) => {
  const noVouchers = vouchers.length === 0
  if (noVouchers) {
    return (
      <Alert
        color='info'
        isOpen={ noVouchers }
      >
        <i className='fas fa-info-circle mr-3' />We could not find any vouchers. :(
      </Alert>
    )
  }
  return (
    vouchers.map((voucher) => (
      <VoucherCard
        key={ `cart-voucher-card-${voucher.id}` }
        voucher={ voucher }
        onClick={ onClickItem }
      />
    ))
  )
}

VoucherList.propTypes = propTypes

export default VoucherList